:host {
  display: block;
}

::slotted([slot=icon]) {
  display: block;
  font-size: 24px;
}

.payment-selected {
  display: flex;
  flex-direction: column;
  gap: var(--sc-spacing-x-small);

  &__label {
    color: var(--sc-input-label-color);
    line-height: var(--sc-line-height-dense);
    font-size: var(--sc-font-size-medium);
  }

  &__instructions {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1em;

    svg {
      width: 42px;
      height: 42px;
      flex-shrink: 0;
    }
  }

  &__instructions-text {
    color: var(--sc-input-label-color);
    font-size: var(--sc-font-size-small);
    line-height: var(--sc-line-height-dense);
  }
}
